// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__jJ0sG","header":"ReportDetails_header__1qBDO","title":"ReportDetails_title__Drbjx","left":"ReportDetails_left__1XAJe"};